import { Dialog } from "@themes/pollinator/ui/Dialog";

export type Props = {
  isOpen: boolean;
  currentDeviceLabel: string;
  onSwitch: () => void | Promise<void>;
  onDismiss: () => void;
};

export function IPhoneMicDialog({
  isOpen,
  currentDeviceLabel,
  onSwitch,
  onDismiss,
}: Props) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onDismiss}
      title="Your iPhone is the active microphone"
      description={`Audio is being picked up from "${currentDeviceLabel}" via macOS Continuity.`}
      isWithActions
      primaryButtonText="Don't use iphone mic"
      onPrimaryClick={onSwitch}
      secondaryButtonText="Dismiss"
      onSecondaryClick={onDismiss}
    />
  );
}
